import React, {
	useCallback,
	useState,
	useEffect,
	createContext,
	useContext,
} from "react";
import AsyncStorage from "@react-native-async-storage/async-storage";
import ConnectionsClient from "../services/ConnectionsClient";
import { CreatorContext } from "./CreatorContext";

export const UserContext = createContext({
	user: null,
	storeUser: () => {},
	getUser: () => {},
});

export const UserProvider = ({ children }) => {
	const { creator, creatorUser } = useContext(CreatorContext);
	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState(null);

	const getUser = useCallback(async () => {
		console.log("getUser called");
		if (creator.isCreator) {
			setUser(creatorUser);
		} else {
			try {
				const token = await AsyncStorage.getItem("token");
				console.log("Token received:", token);
				const headers = token
					? { authorization: token, "x-wc-call": true }
					: {};
				let response = await ConnectionsClient.get("/user", { headers });
				setUser(response.data.user);
			} catch (error) {
				console.error(error);
				await AsyncStorage.removeItem("user");
			}
		}
		setLoading(false);
	}, [creator.isCreator, creatorUser]); // La dependencia es vacía, lo que asegura que `getUser` no cambie

	useEffect(() => {
		getUser();
	}, [getUser]);

	const storeUser = async (user) => {
		setUser(user);
	};

	const logout = async () => {
		try {
			await AsyncStorage.removeItem("token"); // Eliminar el token de AsyncStorage
			setUser(null); // Limpiar el estado del usuario
		} catch (error) {
			console.error("Error during logout:", error);
		}
	};

	return (
		<UserContext.Provider value={{ user, storeUser, getUser, logout }}>
			{loading ? null : children}
		</UserContext.Provider>
	);
};
